import cn from "classnames"
import { Fragment } from "react"

import { Card, Empty, Link, Row } from "@/atoms"
import { useTeasers } from "@/hooks/useTeasers"
import { useTranslation } from "@/hooks/useTranslation"
import { DataReadinessPlaceholder } from "@/molecules/DataReadinessPlaceholder"
import { LoaderWidget } from "@/molecules/Widget"
import { HeadingCard } from "../../molecules/HeadingCard"

import styles from "./CardDashboardTemplate.module.scss"

import type { CardDashboardTemplateProps } from "."

const CardDashboardTemplate = (props: CardDashboardTemplateProps) => {
  const {
    children,
    gutter,
    wrap,
    loading,
    noData,
    className,
    customPlaceholder,
    unavailable,
    to,
    noOverflow,
    ...headingProps
  } = props
  const teasers = useTeasers(props)
  const showPlaceholder = !customPlaceholder && teasers[0]
  const { card: cardClassName, row: rowClassName } = className || {}
  const noLoadingState = !showPlaceholder && !loading
  const showEmpty =
    !showPlaceholder && (unavailable || (noLoadingState && noData))
  const showChildren =
    !showPlaceholder && noLoadingState && !noData && !unavailable
  const showLoading = !showPlaceholder && loading && !unavailable

  const cardCn = cn(styles.card, cardClassName, {
    [styles.loading]: loading,
    [styles.showEmpty]: showEmpty,
    [styles.cardFilter]: !!headingProps.aside,
    [styles.noOverflow]: noOverflow
  })
  const rowCn = cn(styles.row, rowClassName)
  const { t } = useTranslation("translation")
  const Wrapper = to ? Link : Fragment
  const wrapperProps = to ? { to, className: styles.withLink } : {}

  return (
    <Card className={cardCn} title={<HeadingCard {...headingProps} />}>
      <Wrapper {...wrapperProps}>
        <Row className={rowCn} gutter={gutter} wrap={wrap}>
          {showPlaceholder && <DataReadinessPlaceholder {...teasers[1]} />}
          {showLoading && <LoaderWidget />}
          {showEmpty && (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={t(
                unavailable
                  ? "settings.scopes.widgetUnavailable"
                  : "general.noData"
              )}
            />
          )}
          {showChildren && children}
        </Row>
      </Wrapper>
    </Card>
  )
}

export default CardDashboardTemplate
